<template>
  <v-card variant="outlined" max-width="700" elevation="0" class="mx-auto pa-3">
    <v-row
      ><v-col cols="12" sm="12" md="6" class="mx-auto">
        <v-timeline
          align="center"
          side="end"
          truncate-line="both"
          class="py-5"
          line-color="#f5deb3"
          line-thickness="3"
        >
          <v-timeline-item
            v-for="(status, index) in allPageStatus"
            fill-dot
            :key="index"
            :icon="status === 1 ? 'mdi-check' : ''"
            :dot-color="status === 1 ? 'success' : 'secondary'"
            size="x-small"
          >
            <div class="d-flex">
              <v-btn
                class="text-left"
                variant="outlined"
                rounded="lg"
                min-width="260px"
                :color="status === 1 ? 'success' : 'secondary'"
                :to="
                  index === 2
                    ? level_id == '1'
                      ? '/page31'
                      : '/page32'
                    : '/page' + (index + 1)
                "
                :disabled="index > 0 && allPageStatus[index - 1] === 0"
              >
                {{ $t(`main.page${index + 1}`) }}
              </v-btn>
              <v-icon
                v-if="index + 1 < 8"
                class="ml-2 my-auto"
                :color="!is_lock_kmitl1 ? 'info' : 'error'"
                >mdi-{{ !is_lock_kmitl1 ? "lock-open-outline" : "lock" }}
              </v-icon>
              <v-icon
                v-if="index + 1 == 8"
                class="ml-2 my-auto"
                :color="!is_lock_photo ? 'info' : 'error'"
                >mdi-{{ !is_lock_photo ? "lock-open-outline" : "lock" }}
              </v-icon>
              <v-icon
                v-if="index + 1 == 9"
                class="ml-2 my-auto"
                :color="!is_lock_document ? 'info' : 'error'"
                >mdi-{{ !is_lock_document ? "lock-open-outline" : "lock" }}
              </v-icon>
            </div>
          </v-timeline-item>
        </v-timeline>
      </v-col></v-row
    >
    <v-divider></v-divider>
    <v-card-text>
      {{ $t("timeline.symbol") }}
      <v-row class="text-center">
        <v-col cols="12" sm="6">
          <v-icon color="secondary" class="mr-2 my-auto">mdi-circle</v-icon>
          {{ $t("timeline.not_complete") }}
        </v-col>
        <v-col cols="12" sm="6">
          <v-icon color="success" class="mr-2 my-auto"
            >mdi-checkbox-marked-circle</v-icon
          >
          {{ $t("timeline.complete") }}
        </v-col>
      </v-row>
      <v-row class="text-center">
        <v-col cols="12" sm="6">
          <v-icon color="error" class="mr-2 my-auto">mdi-lock</v-icon>
          {{ $t("timeline.can_not_edit") }}
        </v-col>
        <v-col cols="12" sm="6">
          <v-icon color="info" class="mr-2 my-auto"
            >mdi-lock-open-outline</v-icon
          >
          {{ $t("timeline.can_edit") }}
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "TimelineCard",
  props: {
    allPageStatus: Array,
    is_lock_kmitl1: Boolean,
    is_lock_photo: Boolean,
    is_lock_document: Boolean,
    level_id: String,
    modelValue: String,
  },
  data: () => ({
    // completed: [0, 0, 0, 0, 0, 0, 0], // Changed to initial values
  }),
  methods: {
    // toggleCompleted(index) {
    //   this.completed[index] = (this.completed[index] + 1) % 4;
    // },
  },
};
</script>

<style scoped>
.text-left {
  justify-content: left;
}
</style>
